<section class="campaigns-overview-spot" *ngIf="campaigns.length">
    <app-section-header
        [headerTextPrimary]="data?.spotHeader"
    ></app-section-header>

    <ul class="campaigns-overview-spot__list">
        <li
            class="campaigns-overview-spot__campaign-item"
            *ngFor="let campaign of campaigns"
        >
            <div
                class="campaigns-overview-spot__campaign-item-image"
                *ngIf="campaign.campaignImage?.src"
            >
                <app-responsive-image
                    [image]="campaign.campaignImage"
                    [breakpoints]="imageBreakpoints"
                ></app-responsive-image>
            </div>

            <div class="campaigns-overview-spot__campaign-item-content">
                <div
                    class="component-header--small"
                    *ngIf="campaign.categoryText"
                    [innerText]="campaign.categoryText"
                ></div>

                <h3
                    class="h4"
                    *ngIf="campaign.title"
                    [innerText]="campaign.title"
                ></h3>

                <div [innerText]="campaign.introText"></div>

                <a
                    class="
                        button--primary button--themed
                        campaigns-overview-spot__campaign-item-button
                    "
                    *ngIf="campaignPage$ | async as campaignPage"
                    [innerText]="'car_data.campaign_button_text' | translate"
                    [queryParams]="{ id: campaign.id }"
                    [routerLink]="campaignPage"
                ></a>
            </div>
        </li>
    </ul>
</section>
